import styled, { css } from 'styled-components';

import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const ChartWrapper = styled.div`
  height: 210px;
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 0px;
`;

export const LegendWrapper = styled.div`
  width: 100%;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

const activeStyles = css`
  background-color: var(--surface-hover);
  border-radius: 8px;
`;

export const Row = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  cursor: default;

  ${({ $isActive }) => $isActive && activeStyles}

  &:hover {
    ${activeStyles}
  }
`;

export const LegendNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const BodySmallText = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;

export const StyledDot = styled.div<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.$color};
`;
